import { render, staticRenderFns } from "./CustomerDietitianAppointmentList.vue?vue&type=template&id=9192709c&scoped=true&"
import script from "./CustomerDietitianAppointmentList.vue?vue&type=script&lang=js&"
export * from "./CustomerDietitianAppointmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9192709c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VLayout,VRow})
